import {
  CurrencyDollarIcon,
  BanknotesIcon,
  CalendarIcon,
  BuildingLibraryIcon,
  ChartBarIcon,
  UserGroupIcon,
} from "@heroicons/react/20/solid";

import TicketSales from "../apps/TicketSales/TicketSales";
import TransactionsList from "../apps/Transactions/TransactionsList";
import TicketScanner from "../apps/TicketScanner/TicketScanner";
import Events from "../apps/Events/Events";
import Venues from "../apps/Venues/Venues";
import SalesReports from "../apps/SalesReports/SalesReports";
import UserManagement from "../apps/UserManagement/UserManagement";

// Map icon names to their imports
export const iconMap = {
  CurrencyDollarIcon,
  BanknotesIcon,
  CalendarIcon,
  BuildingLibraryIcon,
  ChartBarIcon,
  UserGroupIcon,
};

// Map component names to their imports
export const componentMap = {
  TicketSales,
  TransactionsList,
  TicketScanner,
  Events,
  Venues,
  SalesReports,
  UserManagement,
};
